<template>
    <div class="calendar__popup v-schedule__popup" v-if="cell.showPopup">
        <button class="calendar__close button-icon r-button" @click="closePopupInfo(cell)">
            <span class="screen-reader">Закрыть окно</span>
        </button>
        <div class="v-schedule__p-meta">
            <calendar-popup-meta :cell="cell"></calendar-popup-meta>

            <div class="v-schedule__p-metagroup">
                <span class="v-schedule__p-metaname">Дата приема</span>
                <span class="v-schedule__p-metavalue">{{ startAt }}</span>
                <!--<span class="v-schedule__p-metavalue">{{ cell.appointment.consultation.start_at.format('dd, DD MMM HH:mm') }}</span>-->
            </div>
            <div class="v-schedule__p-metagroup">
                <span class="v-schedule__p-metaname">Тип</span>
                <span class="v-schedule__p-metavalue">{{ cell.appointment.appointment_type.title }}</span>
                <!--<span class="v-schedule__p-metavalue">{{ cell.appointment.consultation.start_at.format('dd, DD MMM HH:mm') }}</span>-->
            </div>
            <div class="v-schedule__p-metagroup" v-if="checkedPay()">
                <span class="v-schedule__p-metaname">Статус:</span>
                <span class="v-schedule__p-metavalue"><b>В процессе оплаты</b></span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    import dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';
    import CalendarPopupMeta from "./CalendarPopupMeta";

    dayjs.extend(utc);

    export default {
        name: 'CalendarPetPopup',
        components: {CalendarPopupMeta},
        props: {
			cell: {
                type: Object,
                required: true
            },
        },
        computed: {
            startAt() {
                return this.cell.appointment.consultation
                    ? dayjs(this.cell.appointment.consultation.start_at).format('dd, DD MMM HH:mm')
                    : null;
            },
            ...mapState([
                'inProcessTypePay',
            ]),

        },
        methods: {
            ...mapMutations([
                'closePopupInfo'
            ]),
            checkedPay() {
                return (this.cell.appointment && this.cell.appointment.consultation.payment && this.cell.booked
                    && this.cell.appointment.consultation.payment.payment_status_id == this.inProcessTypePay);
            }
        },
    }
</script>

